import React, { useState } from "react";
import axios from "../../utils/axiosConfig";
import { useLookup } from "../../utils/useLookup";
import { formatReportDate } from "../../utils/reportDate";

const ClaimReport = () => {
  const { suppliers: shippers, buyers } = useLookup();
  const [filterOption, setFilterOption] = useState("shipper");
  const [supplierId, setSupplierId] = useState("");
  const [claimStatus, setClaimStatus] = useState("all");
  const [rows, setRows] = useState([]);
  const [generated, setGenerated] = useState(false);

  const fmt = formatReportDate;
  const options = filterOption === "shipper" ? shippers : buyers;
  const idKey   = filterOption === "shipper" ? "ShipperID" : "BuyerID";
  const nameKey = filterOption === "shipper" ? "ShipperName" : "BuyerName";

  const handleGenerate = async () => {
    try {
      const body = { filterOption, claimStatus };
      if (supplierId) body.supplierId = Number(supplierId);
      const res = await axios.post("/newdeal/report/claim", body);
      setRows(res.data);
      setGenerated(true);
    } catch { alert("Failed to generate report."); }
  };

  return (
    <div className="container-fluid mt-3">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white">
          <span className="badge bg-success fs-6 px-3 py-2">Claim Report</span>
        </div>
        <div className="card-body">
          <div className="row g-3 mb-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label">Select Filter Option</label>
              <div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" value="shipper" checked={filterOption === "shipper"}
                    onChange={() => { setFilterOption("shipper"); setSupplierId(""); }} />
                  <label className="form-check-label">Shipper wise</label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" value="buyer" checked={filterOption === "buyer"}
                    onChange={() => { setFilterOption("buyer"); setSupplierId(""); }} />
                  <label className="form-check-label">Buyer wise</label>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <label className="form-label">Select Supplier</label>
              <select className="form-select form-select-sm" value={supplierId} onChange={e => setSupplierId(e.target.value)}>
                <option value="">All Supplier</option>
                {options.map(o => <option key={o[idKey]} value={o[idKey]}>{o[nameKey]}</option>)}
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label">Select Status</label>
              <select className="form-select form-select-sm" value={claimStatus} onChange={e => setClaimStatus(e.target.value)}>
                <option value="all">All</option>
                <option value="claim">CLAIM</option>
              </select>
            </div>
            <div className="col-md-2">
              <button className="btn btn-success btn-sm" onClick={handleGenerate}>Generate Report</button>
            </div>
          </div>

          {generated && (
            <>
              <div className="mb-2 text-muted" style={{ fontSize: "13px" }}>Total Records: {rows.length}</div>
              <div style={{ overflowX: "auto" }}>
                <table className="table table-bordered table-hover table-sm" style={{ fontSize: "13px" }}>
                  <thead className="table-success">
                    <tr>
                      <th>#</th><th>Deal ID</th><th>Deal Date</th><th>Buyer</th><th>Shipper</th>
                      <th>Total Qty</th><th>Containers</th><th>Deal Status</th><th>Claim Status</th><th>Claim Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length === 0
                      ? <tr><td colSpan={10} className="text-center text-muted py-3">No records found.</td></tr>
                      : rows.map((r, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td><td>{r.DealID}</td><td>{fmt(r.DealDate)}</td>
                          <td>{r.BuyerName || "-"}</td><td>{r.ShipperName || "-"}</td>
                          <td>{r.TotalQty ?? "-"}</td><td>{r.NoOfContainer ?? "-"}</td>
                          <td>{r.DealStatus ?? "-"}</td><td>{r.ClaimStatus ?? "-"}</td><td>{r.ClaimRemark || "-"}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClaimReport;
